import script from "./blend-item.vue?vue&type=script&setup=true&lang=js"
export * from "./blend-item.vue?vue&type=script&setup=true&lang=js"

import "./blend-item.vue?vue&type=style&index=0&id=475f6a19&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-475f6a19"]])

export default __exports__